import React, { useContext, useEffect, useState } from 'react';
import Footer from '../components/footer';
import { createGlobalStyle } from 'styled-components';
import Pagination from "../components/Pagination";
import { ethers } from "ethers";
import Moment from 'react-moment';
import { addLinkToWhitelist, getUser, getUserNFTsWhitelist, getUserNFTsWhitelistNFTsWhitelistgetUserNFTsWhitelist } from '../../api/api';
import { useNavigate, useParams, Link } from 'react-router-dom';
import {
  ThreeBounce
} from 'better-react-spinkit'
import Swal from 'sweetalert2'
import '@sweetalert2/theme-dark/dark.scss';
const GlobalStyles = createGlobalStyle`
header#myHeader .logo .d-block{
  display: none !important;
}
header#myHeader .logo .d-none{
  display: block !important;
}
.navbar .mainside a{
  background: #8364e2;
  &:hover{
    box-shadow: 2px 2px 20px 0px #8364e2;
  }
}
.item-dropdown{
  .dropdown{
    a{
      &:hover{
        background: #8364e2;
      }
    }
  }
}
.btn-main{
  background: #8364e2;
  &:hover{
    box-shadow: 2px 2px 20px 0px #8364e2;
  }
}
p.lead{
  color: #a2a2a2;
}
.navbar .navbar-item .lines{
  border-bottom: 2px solid #8364e2;
}
.jumbotron.no-bg{
  height: 100vh;
  overflow: hidden;
  background-repeat: repeat;
  background-size: cover;
  background-position: bottom;
  background-repeat: no-repeat;
}
#tsparticles{
  top: 0;
}
.text-uppercase.color{
  color: #8364e2;
}
.de_count h3 {
  font-size: 36px;
  margin-bottom: 0px;
}
.de_count h5{
  font-size: 14px;
  font-weight: 500;
}
h2 {
  font-size: 30px;
}
.box-url{
  text-align: center;
  h4{
    font-size: 16px;
  }
}
.de_countdown{
  border: solid 2px #8364e2;
}
.author_list_pp, .author_list_pp i, 
.nft_coll_pp i, .feature-box.style-3 i, 
footer.footer-light #form_subscribe #btn-subscribe i, 
#scroll-to-top div{
  background: #8364e2;
}
footer.footer-light .subfooter .social-icons span i{
  background: #403f83;
}
.author_list_pp:hover img{
  box-shadow: 0px 0px 0px 2px #8364e2;
}
.nft__item_action span{
  color: #8364e2;
}
.feature-box.style-3 i.wm{
  color: rgba(131,100,226, .1);
}
@media only screen and (max-width: 1199px) {
  .navbar{
    
  }
  .navbar .menu-line, .navbar .menu-line1, .navbar .menu-line2{
    background: #fff;
  }
  .item-dropdown .dropdown a{
    color: #fff !important;
  }
}
.profileBtn{
  width:150px;
  text-align: center;
  margin-top:5px;
}
.fsize32{
  font-size: 42px;
}
.text-left{
  text-align: left;
}
.exemplar_avatar {
  display: flex;
}
`;

const NFTWhitelist = function () {

  const [openMenu, setOpenMenu] = React.useState(true);
  const [openMenu1, setOpenMenu1] = React.useState(false);
  const [openMenu2, setOpenMenu2] = React.useState(false);
  const [openMenu3, setOpenMenu3] = React.useState(false);
  const [openMenu4, setOpenMenu4] = React.useState(false);
  const handleBtnClick = () => {
    setOpenMenu(!openMenu);
    setOpenMenu1(false);
    setOpenMenu2(false);
    setOpenMenu3(false);
    setOpenMenu4(false);
    document.getElementById("follow").classList.remove("active");
    document.getElementById("sale").classList.remove("active");
    document.getElementById("offer").classList.remove("active");
    document.getElementById("like").classList.remove("active");
  };
  const handleBtnClick1 = () => {
    setOpenMenu1(!openMenu1);
    setOpenMenu2(false);
    setOpenMenu(false);
    setOpenMenu3(false);
    setOpenMenu4(false);
    document.getElementById("follow").classList.add("active");
    document.getElementById("sale").classList.remove("active");
    document.getElementById("offer").classList.remove("active");
    document.getElementById("like").classList.remove("active");
  };
  const handleBtnClick2 = () => {
    setOpenMenu2(!openMenu2);
    setOpenMenu(false);
    setOpenMenu1(false);
    setOpenMenu3(false);
    setOpenMenu4(false);
    document.getElementById("follow").classList.remove("active");
    document.getElementById("sale").classList.add("active");
    document.getElementById("offer").classList.remove("active");
    document.getElementById("like").classList.remove("active");
  };
  const handleBtnClick3 = () => {
    setOpenMenu3(!openMenu3);
    setOpenMenu(false);
    setOpenMenu1(false);
    setOpenMenu2(false);
    setOpenMenu4(false);
    document.getElementById("follow").classList.remove("active");
    document.getElementById("sale").classList.remove("active");
    document.getElementById("offer").classList.remove("active");
    document.getElementById("like").classList.add("active");
  };
  const handleBtnClick4 = () => {
    setOpenMenu4(!openMenu4);
    setOpenMenu(false);
    setOpenMenu1(false);
    setOpenMenu3(false);
    setOpenMenu2(false);
    document.getElementById("follow").classList.remove("active");
    document.getElementById("sale").classList.remove("active");
    document.getElementById("offer").classList.add("active");
    document.getElementById("like").classList.remove("active");
  };
  ///////////////
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [items, setItems] = useState([]);
  const getItems = async () => {
    let res = await getUserNFTsWhitelist(currentPage);
    setItems(res.data);
    setTotalRecords(res.totalRecords)
  }
  const [Link1, setLink1] = useState("")
  const [Uploading, setUploading] = useState(false)
  const handleChange1 = (e) => {
    console.log("handleChange: ", e.target.value)
    setLink1(e.target.value)
  }
  let navigate = useNavigate();
  const handleSubmission = async () => {
    if (Link1 === "") {
      return;
    }
    setUploading(true);
    await addLinkToWhitelist({
      link: Link1
    })
    setUploading(false);
    setLink1("")
    const Toast = Swal.mixin({
      toast: true,
      position: 'center-center',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: false,
      didOpen: (toast) => {
        // toast.addEventListener('mouseenter', Swal.stopTimer)
        // toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    })

    Toast.fire({
      icon: 'success',
      title: 'The link added!'
    })
    getItems();

  };
  useEffect(() => {
    getItems();

  }, [currentPage])
  const onPageChange = async (page) => {
    setCurrentPage(page)
  }
  ///////////////
  const shortener = (txt) => {
    return txt.toString().substring(0, 40) + "..." + txt.toString().substring(txt.length-6) 
  }
  const amountFormatter = (amount) => {
    if (!amount) {
      return "0.0"
    }
    return ethers.utils.formatEther(amount)
  }
  const getName = (type) => {
    switch (type) {
      //Depositor Contract
      case "DEPOSIT_FOR_MINT": return "DEPOSIT FOR MINT";
      case "WITHDRAW_FUNDS_DEPOSITOR": return "WITHDRAW ROYALTY CLUSTER A";
      case "CLAIMING_A": return "CLAIM NFT ROYALTY CLUSTER A";
      //Minter Contract
      case "MARKETPLACE_APPROVE": return "MARKETPLACE APPROVE";
      //Central Contract
      case "SALE": return "NTF ON SALE";
      case "CHANGE_PRICE": return "NFT PRICE UPDATE";
      case "CANCEL_SALE": return "REMOVE NTF FROM SALE";
      case "BUY": return "BUY NFT APPROVE";
      case "WITHDRAW_FUNDS_CENTRAL": return "WITHDRAW ROYALTY CLUSTER B";
      case "CLAIMING_B": return "CLAIM NFT ROYALTY CLUSTER B";
      //Signer Contract
      case "SIGN_OFFER": return "AUTOGRAPH REQUEST";
      case "SIGN_OFFER_WITHDRAW": return "CANCEL AUTOGRAPH REQUEST";
      case "SIGN_OFFER_ACCEPT": return "ACCEPT AUTOGRAPH";
      case "WITHDRAW_FUNDS_SIGNER": return "WITHDRAW ROYALTY CLUSTER C";
      case "CLAIMING_C": return "CLAIM NFT ROYALTY CLUSTER C";
      case "AUTOGRAPH_PRICE_CHANGE": return "AUTOGRAPH PRICE CHANGE";
      //Autograph Contract
      case "AUTOGRAPH_SLOT": return "SET AUTOGRAPH";

    }
  }
  return (
    <div>
      <GlobalStyles />

      <section className=' breadcumb no-bg'>
        <div className='mainbreadcumb'>
          <div className='container'>
            <div className='row m-10-hor'>
              <div className='col-12'>
                <h1 className='text-center'>NFTs Whitelist</h1>
                <div className='text-center fontsize12'>If you are an NFT artist and have NFTs minted at other marketplaces(e.g. OpenSea) you can list links to your NFTs here,<br />
                  we review and approve them. You'll receive royalties when on the Lucent NFTs Platform someone mints, makes autographs, or sells your NFTs reference Lucents.</div>
              </div>
            </div>
            <div className='spacer-single'></div>
            <div className='row '>
              <div className='col-md-8 offset-2'>
                <input type="text" name="contract_address1" id="contract_address1" className="form-control xfullname" value={Link1} placeholder="NFT link to marketplace" onChange={(e) => handleChange1(e)} />
                {/* <input type="text" name="contract_address2" id="contract_address2" className="form-control xfullname" value={Link2} placeholder="Instagram" onChange={(e) => handleChange2(e)} /> */}
                {/* <input type="text" name="contract_address3" id="contract_address3" className="form-control xfullname" value={Link3} placeholder="YouTube" onChange={(e) => handleChange3(e)} /> */}
                {/* <input type="text" name="contract_address4" id="contract_address4" className="form-control xfullname" value={Link4} placeholder="WWW" onChange={(e) => handleChange4(e)} /> */}

                <div className=" ">
                  {/* <div className='spacer-single'></div> */}
                  <ul className="de_nav2 ">


                    {(Uploading) && <><ThreeBounce size={14} color='#6f42c1' /><span className="col-purple loadertxt">Please wait...</span></>}
                    {!Uploading && <li id=' ' onClick={() => { console.log("btn3") }} className=" col-white">
                      <span onClick={() => handleSubmission()} className="btn-main fontsize12 "> <span className="">Add Link</span></span>
                    </li>}

                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='container no-top'>

        <div className='container'>
          <div className="spacer-double"></div>
          <table className="table de-table table-rank">
            <thead>
              <tr>
                <th scope="col">Date</th>
                <th scope="col">Link</th>
                {/* <th scope="col">TxHash</th> */}
                <th scope="col">Status</th>
              </tr>
              <tr></tr>
            </thead>
            <tbody>
              {items && items.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>
                      <span className="color-grey fontsize12">
                        {(item.createdAt || item.updatedAt) && <Moment format="HH:mm DD MMMM YYYY">
                          {item.updatedAt || item.createdAt}
                        </Moment>}
                      </span>
                    </td>
                    <td>{item.link && <><a className=' color' href={item.link} target="_blank"><span >{shortener(item.link)}  <span className="fa fa-link "></span></span></a></>}</td>
                    <td className="fontsize12">
                      {item && item.status === 0 && <div className="statusLabel-yellow">INREVIEW</div>}
                      {item && item.status === 1 && <div className="statusLabel-green">APPROVED</div>}
                      {item && item.status === 2 && <div className="statusLabel-red">REJECTED</div>}
                    </td>
                  </tr>
                )
              })}


            </tbody>
          </table>

        </div>
      </section>
      <section className="container no-top">
        <div ><Pagination onPageChange={onPageChange} _currentPage={currentPage} recordsPerPage={10} pageNumberLimit={5} totalRecords={totalRecords} /></div>
      </section>
      <Footer />
    </div>

  );
}

export default NFTWhitelist;